import angular from 'angular'
import component from './imageFocalPoint.component'

export default angular
  .module('ellipsis.imageFocalPoint', [])
  .component('imageFocalPoint', component)
